package ru.villawonka.app.platform

import kotlinx.browser.window
import ru.villawonka.app.BuildConfig
import ru.villawonka.app.AppConfig

class JsSentry : Sentry {

    private val sentry by lazy { window.asDynamic().Sentry }

    override fun init() {
        sentry.onLoad({
            val config = js("{}")
            config.release = "villawonka-miniapp@${AppConfig.APP_VERSION}"
            config.environment = BuildConfig.buildType
            config.tracesSampleRate = 1.0
            config.replaysSessionSampleRate = 0.1
            config.replaysOnErrorSampleRate = 1.0
            sentry.init(config)
        })
    }


    override fun captureException(throwable: Throwable) {
        sentry.captureException(throwable)
    }

    override fun captureMessage(message: String) {
        sentry.captureMessage(message)
    }

    override fun captureEvent(message: String, level: String) {
        sentry.captureEvent(message, level)
    }

    override fun addBreadcrumb(category: String, message: String, level: String) {
        sentry.addBreadcrumb(category, message, level)
    }
}